<template>
  <div>
    <div class="monthly-payment">
      <div class="value">{{ this.FORMATED_BREAKDOWN_PAYMENT}}</div>
      <div class="title">MONTHLY PAYMENT</div>
    </div>
    <canvas id="PaymentBreakdownCanvas"></canvas>
  </div>
</template>
<script>
import Chart from "chart.js";
import { mapState, mapGetters } from "vuex";
import { STATE, MUTATIONS, GETTERS } from "../storeConstants";
import PaymentBreakdownChartData from "./chartData/PaymentBreakdownChartData";

const { PAYMENT, FORMATED_BREAKDOWN_PAYMENT } = GETTERS;

export default {
  mounted() {
    this.$nextTick(() => {
      //  / this.chart();
    });
  },
  data: function() {
    return {
      doughnut: {}
    };
  },
  watch: {
    chartData: function() {
      this.chart();
    },
    display() {
      this.chart();
    }
  },
  methods: {
    chart() {
      const chart = new Chart(this.ctx, this.chartData);
    }
  },

  computed: {
    ...mapState({
      state: state => state.base
    }),
    display() {
      return this.state.CURRENT_DISPLAY;
    },
    ...mapGetters([PAYMENT, FORMATED_BREAKDOWN_PAYMENT]),
    ctx() {
      return this.hasShadowRoot
        ? document
            .getElementsByTagName("mortgage-calculator")[0]
            .shadowRoot.getElementById("PaymentBreakdownCanvas")
        : document.getElementById("PaymentBreakdownCanvas");
    },
    hasShadowRoot() {
      return !!document.getElementsByTagName("mortgage-calculator").length;
    },
    chartData() {
      return PaymentBreakdownChartData({
        ...this.state,
        PAYMENT: this.PAYMENT,
        // MODIFIED_TERM: this.MODIFIED_TERM,
        CHANGE: this.CHANGE
      });
    }
  }
};
</script>

<style scoped lang="scss">
.payment-breakdown-graph {
  position: relative;
  height: 272px !important;
}
@media (min-width: 25px) {
  .payment-breakdown-graph {
    margin-top: 25px;
  }
}
.monthly-payment {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 272px;
  height: 272px;
  align-items: center;
  justify-content: center;
  font-family: Poppins;
}
.monthly-payment .value {
  color: #000;
  line-height: 1;
  font-size: 45px;
}
@supports ((-webkit-background-clip: text) or (background-clip: text)) {
  .monthly-payment .value {
    color: transparent;
    background-image: linear-gradient(90deg, #60c5b7, #acd14c),
      linear-gradient(180deg, #fff, #fff);
    background-clip: text;
  }
}
.monthly-payment .title {
  font-size: 14px;
  margin-top: 14px;
  line-height: 1;
  font-weight: 400;
  color: grey;
}
canvas {
  height: 272px !important;
  width: 100% !important;
}
</style>